import { i as isBrowserScope, N as FEATURE_NAME, B as deregisterDrain, t as defaultRegister, o as SUPPORTABILITY_METRIC_CHANNEL, C as CUSTOM_METRIC_CHANNEL, p as getRuntime, q as getConfiguration, O as onDOMContentLoaded, Q as isWorkerScope, w as windowAddEventListener, R as SUPPORTABILITY_METRIC, T as CUSTOM_METRIC } from './micro-agent-8d9a9dc2.js';
import { H as HarvestScheduler } from './harvest-scheduler-11ef3da0.js';
import { A as AggregateBase, i as isFileProtocol, g as getRules, v as validateRules } from './aggregate-base-619aa2ce.js';
import './page-visibility-48795b15.js';
import './stringify-d8602ca9.js';

const FRAMEWORKS = {
  REACT: 'React',
  NEXTJS: 'NextJS',
  VUE: 'Vue',
  NUXTJS: 'NuxtJS',
  ANGULAR: 'Angular',
  ANGULARUNIVERSAL: 'AngularUniversal',
  SVELTE: 'Svelte',
  SVELTEKIT: 'SvelteKit',
  PREACT: 'Preact',
  PREACTSSR: 'PreactSSR',
  ANGULARJS: 'AngularJS',
  BACKBONE: 'Backbone',
  EMBER: 'Ember',
  METEOR: 'Meteor',
  ZEPTO: 'Zepto',
  JQUERY: 'Jquery',
  MOOTOOLS: 'MooTools',
  QWIK: 'Qwik',
  ELECTRON: 'Electron'
};
function getFrameworks() {
  if (!isBrowserScope) return []; // don't bother detecting frameworks if not in the main window context

  const frameworks = [];
  try {
    if (detectReact()) {
      frameworks.push(FRAMEWORKS.REACT);
      if (detectNextJS()) frameworks.push(FRAMEWORKS.NEXTJS);
    }
    if (detectVue()) {
      frameworks.push(FRAMEWORKS.VUE);
      if (detectNuxtJS()) frameworks.push(FRAMEWORKS.NUXTJS);
    }
    if (detectAngular()) {
      frameworks.push(FRAMEWORKS.ANGULAR);
      if (detectAngularUniversal()) frameworks.push(FRAMEWORKS.ANGULARUNIVERSAL);
    }
    if (detectSvelte()) {
      frameworks.push(FRAMEWORKS.SVELTE);
      if (detectSvelteKit()) frameworks.push(FRAMEWORKS.SVELTEKIT);
    }
    if (detectPreact()) {
      frameworks.push(FRAMEWORKS.PREACT);
      if (detectPreactSSR()) frameworks.push(FRAMEWORKS.PREACTSSR);
    }
    if (detectAngularJs()) frameworks.push(FRAMEWORKS.ANGULARJS);
    if (Object.prototype.hasOwnProperty.call(window, 'Backbone')) frameworks.push(FRAMEWORKS.BACKBONE);
    if (Object.prototype.hasOwnProperty.call(window, 'Ember')) frameworks.push(FRAMEWORKS.EMBER);
    if (Object.prototype.hasOwnProperty.call(window, 'Meteor')) frameworks.push(FRAMEWORKS.METEOR);
    if (Object.prototype.hasOwnProperty.call(window, 'Zepto')) frameworks.push(FRAMEWORKS.ZEPTO);
    if (Object.prototype.hasOwnProperty.call(window, 'jQuery')) frameworks.push(FRAMEWORKS.JQUERY);
    if (Object.prototype.hasOwnProperty.call(window, 'MooTools')) frameworks.push(FRAMEWORKS.MOOTOOLS);
    if (Object.prototype.hasOwnProperty.call(window, 'qwikevents')) frameworks.push(FRAMEWORKS.QWIK);
    if (detectElectron()) frameworks.push(FRAMEWORKS.ELECTRON);
  } catch (err) {
    // Possibly not supported
  }
  return frameworks;
}
function detectReact() {
  try {
    return Object.prototype.hasOwnProperty.call(window, 'React') || Object.prototype.hasOwnProperty.call(window, 'ReactDOM') || Object.prototype.hasOwnProperty.call(window, 'ReactRedux') || document.querySelector('[data-reactroot], [data-reactid]') || (() => {
      const divs = document.querySelectorAll('body > div');
      for (let i = 0; i < divs.length; i++) {
        if (Object.prototype.hasOwnProperty.call(divs[i], '_reactRootContainer')) {
          return true;
        }
      }
    })();
  } catch (err) {
    return false;
  }
}
function detectNextJS() {
  // React SSR
  try {
    return Object.prototype.hasOwnProperty.call(window, 'next') && Object.prototype.hasOwnProperty.call(window.next, 'version');
  } catch (err) {
    return false;
  }
}
function detectVue() {
  try {
    return Object.prototype.hasOwnProperty.call(window, 'Vue');
  } catch (err) {
    return false;
  }
}
function detectNuxtJS() {
  // Vue SSR
  try {
    return Object.prototype.hasOwnProperty.call(window, '$nuxt') && Object.prototype.hasOwnProperty.call(window.$nuxt, 'nuxt');
  } catch (err) {
    return false;
  }
}
function detectAngular() {
  try {
    return Object.prototype.hasOwnProperty.call(window, 'ng') || document.querySelector('[ng-version]');
  } catch (err) {
    return false;
  }
}
function detectAngularUniversal() {
  // Anguler SSR
  try {
    return document.querySelector('[ng-server-context]');
  } catch (err) {
    return false;
  }
}
function detectSvelte() {
  try {
    return Object.prototype.hasOwnProperty.call(window, '__svelte');
  } catch (err) {
    return false;
  }
}
function detectSvelteKit() {
  // Svelte SSR
  try {
    return !!Object.keys(window).find(prop => prop.startsWith('__sveltekit'));
  } catch (err) {
    return false;
  }
}
function detectPreact() {
  try {
    return Object.prototype.hasOwnProperty.call(window, 'preact');
  } catch (err) {
    return false;
  }
}
function detectPreactSSR() {
  // Svelte SSR
  try {
    return document.querySelector('script[type="__PREACT_CLI_DATA__"]');
  } catch (err) {
    return false;
  }
}
function detectAngularJs() {
  try {
    return Object.prototype.hasOwnProperty.call(window, 'angular') || document.querySelector('.ng-binding, [ng-app], [data-ng-app], [ng-controller], [data-ng-controller], [ng-repeat], [data-ng-repeat]') || document.querySelector('script[src*="angular.js"], script[src*="angular.min.js"]');
  } catch (err) {
    return false;
  }
}
function detectElectron() {
  try {
    return typeof navigator === 'object' && typeof navigator.userAgent === 'string' && navigator.userAgent.indexOf('Electron') >= 0;
  } catch (err) {
    return false;
  }
}

class Aggregate extends AggregateBase {
  static featureName = FEATURE_NAME;
  constructor(agentIdentifier, aggregator) {
    super(agentIdentifier, aggregator, FEATURE_NAME);
    this.waitForFlags(['err']).then(_ref => {
      let [errFlag] = _ref;
      if (errFlag) {
        // *cli, Mar 23 - Per NR-94597, this feature should only harvest ONCE at the (potential) EoL time of the page.
        const scheduler = new HarvestScheduler('jserrors', {
          onUnload: () => this.unload()
        }, this);
        // this is needed to ensure EoL is "on" and sent
        scheduler.harvest.on('jserrors', () => ({
          body: this.aggregator.take(['cm', 'sm'])
        }));
        this.drain();
      } else {
        this.blocked = true; // if rum response determines that customer lacks entitlements for spa endpoint, this feature shouldn't harvest
        deregisterDrain(this.agentIdentifier, this.featureName);
      }
    });

    // Allow features external to the metrics feature to capture SMs and CMs through the event emitter
    defaultRegister(SUPPORTABILITY_METRIC_CHANNEL, this.storeSupportabilityMetrics.bind(this), this.featureName, this.ee);
    defaultRegister(CUSTOM_METRIC_CHANNEL, this.storeEventMetrics.bind(this), this.featureName, this.ee);
    this.singleChecks(); // checks that are run only one time, at script load
    this.eachSessionChecks(); // the start of every time user engages with page
  }
  storeSupportabilityMetrics(name, value) {
    if (this.blocked) return;
    const type = SUPPORTABILITY_METRIC;
    const params = {
      name
    };
    this.aggregator.storeMetric(type, name, params, value);
  }
  storeEventMetrics(name, metrics) {
    if (this.blocked) return;
    const type = CUSTOM_METRIC;
    const params = {
      name
    };
    this.aggregator.store(type, name, params, metrics);
  }
  singleChecks() {
    // report loaderType
    const {
      distMethod,
      loaderType
    } = getRuntime(this.agentIdentifier);
    const {
      proxy,
      privacy,
      page_view_timing
    } = getConfiguration(this.agentIdentifier);
    if (loaderType) this.storeSupportabilityMetrics("Generic/LoaderType/".concat(loaderType, "/Detected"));
    if (distMethod) this.storeSupportabilityMetrics("Generic/DistMethod/".concat(distMethod, "/Detected"));
    if (isBrowserScope) {
      this.storeSupportabilityMetrics('Generic/Runtime/Browser/Detected');
      const nonce = document?.currentScript?.nonce;
      if (nonce && nonce !== '') {
        this.storeSupportabilityMetrics('Generic/Runtime/Nonce/Detected');
      }

      // These SMs are used by the AppExp team
      onDOMContentLoaded(() => {
        getFrameworks().forEach(framework => {
          this.storeSupportabilityMetrics('Framework/' + framework + '/Detected');
        });
      });
      if (!privacy.cookies_enabled) this.storeSupportabilityMetrics('Config/SessionTracking/Disabled');
      if (page_view_timing.long_task) this.storeSupportabilityMetrics('Config/LongTask/Enabled');
    } else if (isWorkerScope) {
      this.storeSupportabilityMetrics('Generic/Runtime/Worker/Detected');
    } else {
      this.storeSupportabilityMetrics('Generic/Runtime/Unknown/Detected');
    }

    // Track if the agent is being loaded using a file protocol such as is the case in some
    // set-top box applications or Electron applications
    if (isFileProtocol()) {
      this.storeSupportabilityMetrics('Generic/FileProtocol/Detected');
    }

    // Capture SMs to assess customer engagement with the obfuscation config
    const rules = getRules(this.agentIdentifier);
    if (rules.length > 0) this.storeSupportabilityMetrics('Generic/Obfuscate/Detected');
    if (rules.length > 0 && !validateRules(rules)) this.storeSupportabilityMetrics('Generic/Obfuscate/Invalid');

    // Check if proxy for either chunks or beacon is being used
    if (proxy.assets) this.storeSupportabilityMetrics('Config/AssetsUrl/Changed');
    if (proxy.beacon) this.storeSupportabilityMetrics('Config/BeaconUrl/Changed');
    if (isBrowserScope && window.MutationObserver) {
      this.storeSupportabilityMetrics('Generic/VideoElement/Added', window.document.querySelectorAll('video').length);
      const mo = new MutationObserver(records => {
        records.forEach(record => {
          record.addedNodes.forEach(addedNode => {
            if (addedNode instanceof HTMLVideoElement) {
              this.storeSupportabilityMetrics('Generic/VideoElement/Added', 1);
            }
          });
        });
      });
      mo.observe(window.document.body, {
        childList: true,
        subtree: true
      });
    }
  }
  eachSessionChecks() {
    if (!isBrowserScope) return;

    // [Temporary] Report restores from BFCache to NR1 while feature flag is in place in lieu of sending pageshow events.
    windowAddEventListener('pageshow', evt => {
      if (evt?.persisted) {
        this.storeSupportabilityMetrics('Generic/BFCache/PageRestored');
      }
    });
  }
  unload() {
    try {
      if (this.resourcesSent) return;
      this.resourcesSent = true; // make sure this only gets sent once

      // Capture SMs around network resources using the performance API to assess
      // work to split this out from the ST nodes
      // differentiate between internal+external and ajax+non-ajax
      const ajaxResources = ['beacon', 'fetch', 'xmlhttprequest'];
      const internalUrls = ['nr-data.net', 'newrelic.com', 'nr-local.net', 'localhost'];
      function isInternal(x) {
        return internalUrls.some(y => x.name.indexOf(y) >= 0);
      }
      function isAjax(x) {
        return ajaxResources.includes(x.initiatorType);
      }
      const allResources = performance?.getEntriesByType('resource') || [];
      allResources.forEach(entry => {
        if (isInternal(entry)) {
          if (isAjax(entry)) this.storeSupportabilityMetrics('Generic/Resources/Ajax/Internal');else this.storeSupportabilityMetrics('Generic/Resources/Non-Ajax/Internal');
        } else {
          if (isAjax(entry)) this.storeSupportabilityMetrics('Generic/Resources/Ajax/External');else this.storeSupportabilityMetrics('Generic/Resources/Non-Ajax/External');
        }
      });

      // Capture SMs for performance markers and measures to assess the usage and possible inclusion of this
      // data in the agent for use in NR
      if (typeof performance !== 'undefined') {
        const markers = performance.getEntriesByType('mark');
        const measures = performance.getEntriesByType('measure');
        this.storeSupportabilityMetrics('Generic/Performance/Mark/Seen', markers.length);
        this.storeSupportabilityMetrics('Generic/Performance/Measure/Seen', measures.length);
      }
    } catch (e) {
      // do nothing
    }
  }
}

export { Aggregate };
//# sourceMappingURL=index-1dced7db.js.map
